/**
 * Generated by orval 🍺
 * Do not edit manually.
 * React Admin API
 * OpenAPI spec version: 1.0.0
 */

import { openApiRequest } from '../openapi';
import type {
  FakeCaptcha,
  GetFakeCaptchaParams,
  LoginParams,
  LoginResult,
  SuccessResponse,
} from './model';

export const getLoginUrl = () => {
  return `/api/login/account`;
};

/**
 * 登录
 */
export const login = async (
  loginParams: LoginParams,
  options?: Parameters<typeof openApiRequest>[1],
): Promise<LoginResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(
      h,
    )) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return openApiRequest<LoginResult>(getLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginParams),
  });
};

export const getOutLoginUrl = () => {
  return `/api/login/outLogin`;
};

/**
 * 退出登录
 */
export const outLogin = async (
  options?: Parameters<typeof openApiRequest>[1],
): Promise<SuccessResponse> => {
  return openApiRequest<SuccessResponse>(getOutLoginUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getGetFakeCaptchaUrl = (params?: GetFakeCaptchaParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/login/captcha?${stringifiedParams}`
    : `/api/login/captcha`;
};

/**
 * 发送验证码
 */
export const getFakeCaptcha = async (
  params?: GetFakeCaptchaParams,
  options?: Parameters<typeof openApiRequest>[1],
): Promise<FakeCaptcha> => {
  return openApiRequest<FakeCaptcha>(getGetFakeCaptchaUrl(params), {
    ...options,
    method: 'GET',
  });
};
